var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cl-paper',{class:[
   'cl-snackbar-content',
   ("cl-snackbar-content--color-" + _vm.color)
  ],attrs:{"role":"alertdialog","square":"","elevation":6}},[_c('cl-typography',{staticClass:"cl-snackbar-content__message",attrs:{"color":"inherit"}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_vm._t("actions")],2)}
var staticRenderFns = []

export { render, staticRenderFns }